<script setup lang="ts">
import merge from 'lodash-es/merge';
import { DateTime } from 'luxon';

defineOptions({
    name: 'WidgetBannerSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const { $t } = useLocalization();

const defaults = ref<any>({
    datePublishedUtc: DateTime.now(),
    type: 'text',
    scriptText: '',
    url: '',
    openNewTab: false,
    image: null
});

const form = computed<any>(() =>
{
    return props.modelValue;
});

const typeOptions = computed<Option[]>(() =>
{
    return [
        { value: 'text', text: $t('[[[Tekstowy / HTML / JS]]]') },
        { value: 'image', text: $t('[[[Obraz]]]') }
    ];
});

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

async function typeChanged(): Promise<void>
{
    form.value.settings = {
        datePublishedUtc: DateTime.now(),
        type: form.value.settings.type,
        scriptText: '',
        url: '',
        openNewTab: false,
        image: null
    };
}

watch(() => form.value.settings, () =>
{
    triggerModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <div class="row">
        <div class="col-6">
            <IdeoFormGroup :label="$t('[[[Publikuj od]]]')" :invalid-feedback="form.$errors.first(`settings.datePublishedUtc`)" :state="form.$errors.state(`settings.datePublishedUtc`)" required>
                <IdeoDatetime v-model="form.settings.datePublishedUtc" type="datetime" name="datePublishedUtc" />
            </IdeoFormGroup>
        </div>
        <div class="col-6">
            <IdeoFormGroup :label="$t('[[[Publikuj do]]]')" :invalid-feedback="form.$errors.first(`settings.dateDismissedUtc`)" :state="form.$errors.state(`settings.dateDismissedUtc`)">
                <IdeoDatetime v-model="form.settings.dateDismissedUtc" type="datetime" name="dateDismissedUtc" />
            </IdeoFormGroup>
        </div>
    </div>

    <IdeoFormGroup :label="$t('[[[Typ bannera]]]')" :invalid-feedback="form.$errors.first('settings.type')" :state="form.$errors.state('settings.type')">
        <IdeoFormSelect v-model="form.settings.type" :options="typeOptions" value-field="value" text-field="text" @change="typeChanged" />
    </IdeoFormGroup>

    <IdeoFormGroup v-if="form.settings.type == 'text'" :label="$t('[[[Kod bannera (tutaj wklej kod HTML i JS)]]]')" :invalid-feedback="form.$errors.first('settings.content')" :state="form.$errors.state('settings.content')">
        <IdeoFormTextarea v-model="form.settings.scriptText" name="scriptText" rows="10" />
    </IdeoFormGroup>

    <div v-if="form.settings.type == 'image'">
        <IdeoFormGroup :label="$t('[[[Odnośnik URL]]]')" :invalid-feedback="form.$errors.first('settings.url')" :state="form.$errors.state('settings.url')">
            <IdeoFormInput v-model="form.settings.url" type="text" name="url" />
        </IdeoFormGroup>

        <IdeoFormGroup :invalid-feedback="form.$errors.first('settings.openNewTab')" :state="form.$errors.state('settings.openNewTab')" :nospace="true">
            <IdeoFormCheckbox v-model="form.settings.openNewTab" switch>
                {{ $t('[[[Otwieraj w nowym oknie]]]') }}
            </IdeoFormCheckbox>
        </IdeoFormGroup>

        <IdeoFormGroup :label="$t('[[[Plik graficzny]]]')" :invalid-feedback="form.$errors.first(`settings.image`)" :state="form.$errors.state(`settings.image`)">
            <IdeoFilePicker v-model="form.settings.image" media="images" />
        </IdeoFormGroup>
    </div>
</template>
